module.exports = __webpack_public_path__ + "img/icon-folder.a330a5af.svg";